import { apiUrl } from "utils/urls";

import axios from "axios";

export const postPaymentBillingKey = async (body) => {
    const { data } = await axios.post(apiUrl("paymentBillingKey"), body);
    return data;
};

export const getPaymentBillingKeyList = async (params) => {
    const { data } = await axios.get(apiUrl("paymentBillingKey"), {
        params: params,
    });
    return data;
};

export const deletePaymentBillingKey = async (id) => {
    const { data } = await axios.delete(apiUrl("paymentBillingKey") + "/" + id);
    return data;
};

export const getPaymentBillingHistory = async (params) => {
    const { data } = await axios.get(apiUrl("paymentBillingHistory"), {
        params: params,
    });
    return data;
};

export const getPaymentPlan = async (params) => {
    const { data } = await axios.get(apiUrl("paymentPlan"), { params: params });
    return data;
};

export const getPaymentPlanSubscriptionHistory = async (params) => {
    const { data } = await axios.get(apiUrl("paymentPlanSubscriptionHistory"), {
        params: params,
    });
    return data;
};

export const postPaymentPlanSubscriptionHistory = async (body) => {
    const { data } = await axios.post(apiUrl("paymentPlanSubscriptionHistory"), body);
    return data;
};

export const patchPaymentPlanSubscriptionHistory = async (body) => {
    const { data } = await axios.patch(apiUrl("paymentPlanSubscriptionHistory") + "/" + body.id, body);
    return data;
};

export const extendPaymentPlanSubscriptionHistory = async (body) => {
    const { data } = await axios.patch(
        apiUrl("paymentPlanSubscriptionHistory") + "/" + body.id + "/extend-subscribe",
        body,
    );
    return data;
};

export const getPaymentCoupon = async (params) => {
    const { data } = await axios.get(apiUrl("paymentCoupon"), { params: params });
    return data;
};

export const postPaymentCoupon = async (body) => {
    const { data } = await axios.post(apiUrl("paymentCouponUse"), body);
    return data;
};

export const registerPaymentCoupon = async (body) => {
    const { data } = await axios.post(apiUrl("paymentCouponRegister"), body);
    return data;
};

export const getPaymentPlanGroupUser = async (params) => {
    const { data } = await axios.get(apiUrl("paymentPlanGroup") + `/${params.group_id}/user`, { params: params });
    return data;
};

export const postPaymentPlanGroupUser = async (body) => {
    const { data } = await axios.post(apiUrl("paymentPlanGroup") + `/${body.group_id}/user`, body);
    return data;
};

export const deletePaymentPlanGroupUser = async (params) => {
    const { data } = await axios.delete(apiUrl("paymentPlanGroup") + `/${params.group_id}/user/${params.id}`, {
        params: params,
    });
    return data;
};

export const patchPaymentPlanGroupUser = async (body) => {
    const { data } = await axios.post(apiUrl("paymentPlanGroup") + `/${body.group_id}/user/${body.type}`, body);
    return data;
};

export const getPaymentPlanGroup = async (params) => {
    const { data } = await axios.get(apiUrl("paymentPlanGroup"), { params: params });
    return data;
};

export const getPaymentDiscountPolicy = async (params) => {
    const { data } = await axios.get(apiUrl("paymentDiscountPolicy"), { params: params });
    return data;
};

export const patchPaymentPlanGroup = async (body) => {
    const { data } = await axios.patch(apiUrl("paymentPlanGroup"), body);
    return data;
};
